<script lang="ts">
    import PatternViewer from './../PatternViewer.svelte';

    export let selectedPatternId: number;
</script>



<PatternViewer patternId={selectedPatternId} />
